<div class="stripe-card" role="region" aria-live="polite" #stripeView>
  <div
    id="stripe-instructions"
    class="visually-hidden"
    role="status"
  >
    Secure credit card payment section. Enter your card details to complete the payment.
  </div>
  @if (stripeLoading) {
    <div class="row skeleton-animation" role="status" aria-live="polite">
      <div class="d-flex gap-3">
        <div class="bar w-50"></div>
        <div class="bar w-25"></div>
        <div class="bar w-25"></div>
      </div>
      <div>
        <div class="bar mt-3"></div>
        <div class="bar mt-3"></div>
      </div>
    </div>
  }
  <div [class]="{'d-none': stripeLoading}">
    <ng-container *calioLightDomProjection>
      @if (elementsOptions?.clientSecret) {
        <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
          <ngx-stripe-payment (ready)="onReady()" (loaderror)="onLoadError($event)" />
        </ngx-stripe-elements>
      }
    </ng-container>
  </div>
  @if (errorMessage) {
    <div class="alert alert-danger summary-warning mt-2" role="alert">
      {{ errorMessage }}
    </div>
  }
</div>
